export default __webpack_public_path__ + "static/media/dora.3b3222c3.png";